import { useMutation } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";
import { FinishUploadPayload } from "./@types";

const finishAttachmentDownload = async (payload: FinishUploadPayload) => {
  const { data } = await apiInputService.post(
    "/ValidationSteps/proceed/finishDownload",
    payload,
  );

  return data;
};

export const useFinishAttachmentDownload = (options?: any) => {
  return useMutation(finishAttachmentDownload, {
    ...options,
  });
};
